export const NUMBER_OF_SCANNER_FIELDS = 14;
export const SCANNER_PREFIX = '$';
export const SCANNER_SUFFIX = '$';
export const SCANNER_DELIMITER = '\n';

export const SCANNER_FIELD_NAME_BY_POSITION = {
  HRVHUB: 0,
  CCY: 1,
  AMT: 2,
  DBTRNM: 3,
  DBTRADDRESS: 4,
  DBTRLOCATION: 5,
  CRDTRNM: 6,
  CRDTRADDRESS: 7,
  CRDTRLOCATION: 8,
  IBAN: 9,
  MODEL: 10,
  CALL_NUM: 11,
  CODE: 12,
  INFO: 13,
};

export default {
  SCANNER_FIELD_NAME_BY_POSITION,
  NUMBER_OF_SCANNER_FIELDS,
  SCANNER_PREFIX,
  SCANNER_SUFFIX,
};
